import { Box, ListItem } from '@rulebooks/evidend-titan';
import { formatUboGround, formatUboOwnershipRange } from 'helpers/ubo';
import type { SummaryCardsComponentProps } from 'helpers/formatMutation';
import React from 'react';
import { ShareholderCapitalCard } from 'summaries/CapitalCards/ShareholderCapitalCard';

export const UboSummaryCards = ({
  backgroundVariant = 'white',
  mutation,
}: SummaryCardsComponentProps) => {
  const ubos = mutation.ubo || [];

  return (
    <>
      {!!ubos.length && (
        <Box spaceAfter={10}>
          {ubos.map((ubo, index) => (
            <ShareholderCapitalCard
              key={index}
              backgroundVariant={backgroundVariant}
              party={ubo.naturalPerson}
            >
              <ListItem prefixAdornment="•">{formatUboGround(ubo.ground)}</ListItem>
              {ubo.ownershipRange && (
                <ListItem prefixAdornment="•">
                  {formatUboOwnershipRange(ubo.ownershipRange)}
                </ListItem>
              )}
            </ShareholderCapitalCard>
          ))}
        </Box>
      )}
    </>
  );
};
